import { useSelector } from 'react-redux';
import { AdminAdvertisingLayout } from '../../../../common/components';
import AdvertisingCampaign from '../../../common/advertising-campaign/AdvertisingCampaign';
import { getUser } from '../../../../common/store';

const AdminAdvertisingCampaign = () => {
    const user = useSelector(getUser);
    const orgId = user?.org?.id;

    return (
        <AdminAdvertisingLayout title="Campanhas de publicidade">
            <AdvertisingCampaign orgId={orgId} />
        </AdminAdvertisingLayout>
    );
};

export default AdminAdvertisingCampaign;
